import styled from "styled-components";

export const SubscriptionContainer = styled.div`
  width: 100%;
  margin-bottom: 25px;

  .content-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 30px;

    @media (min-width: 768px) {
      justify-content: center;
      gap: 50px;
    }
  }
`;
